export default __webpack_public_path__ + "static/media/610.73338e27.png";